import { createContext } from 'react';

export type EditSignerCtx = {
  showEditSignerErrorAlert: boolean;
};

const EditSignerContext = createContext<EditSignerCtx>({
  showEditSignerErrorAlert: false,
});

export default EditSignerContext;
